module.exports = __webpack_public_path__ + "static/media/Dodger-4887734382_6a6efc744a_z.053d0110.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Dodger-4887734382_6a6efc744a_z.jpg
// module id = 25
// module chunks = 0